























import mixins from 'vue-typed-mixins'
import AbstractScriptTemplateItem from '../abstract'

export default mixins(AbstractScriptTemplateItem).extend<{}, {}, {}, {}>({})
